export default "__VITE_ASSET__BRxvf5Cw__"